import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { countPending, onPendingCreatorsChanged } from '../../../services/pendingCreatorsService';

// Count badges for navigation items that set `badge`. No permission or no count means no badge.
const BADGE_SOURCES = {
  pendingCreators: {
    permission: 'manage_creators',
    load: signal => countPending({ signal }).then(counts => counts?.count),
    subscribe: onPendingCreatorsChanged
  }
};

const NavigationBadge = ({ badge }) => {
  const { hasPermission } = useAuth() || {};
  const source = BADGE_SOURCES[badge];
  const allowed = Boolean(source) && typeof hasPermission === 'function' && hasPermission(source.permission);
  const [value, setValue] = useState(null);
  const [version, setVersion] = useState(0);

  useEffect(() => (allowed ? source.subscribe(() => setVersion(current => current + 1)) : undefined), [allowed, source]);

  useEffect(() => {
    if (!allowed) {
      setValue(null);
      return undefined;
    }
    const controller = new AbortController();
    source.load(controller.signal)
      .then(count => { if (!controller.signal.aborted) setValue(Number.isFinite(count) && count > 0 ? count : null); })
      .catch(() => { if (!controller.signal.aborted) setValue(null); });
    return () => controller.abort();
  }, [allowed, source, version]);

  if (!value) return null;
  return (
    <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-[999px] bg-surface-3 px-1.5 text-[11px] font-semibold tabular-nums text-text-secondary" data-testid={`nav-badge-${badge}`}>
      <span className="sr-only">, </span>
      {value > 999 ? '999+' : value}
    </span>
  );
};

export default NavigationBadge;
